import '/app/brewery-packages/content/content-editor-plugin-paragraph/src/Paragraph.css-raw';
export default {
  "paragraph": "contacts-cbf4f629-paragraph-WaWZGW"
};